import { outerHeight } from "@grindex-common/helpers/domManipulation";

function refreshSlider($slider) {
	const $sections = $slider.querySelectorAll("li section");
	if ($sections.length) {
		const height = Array.prototype.reduce.call(
			Array.prototype.map.call($sections, (e) => outerHeight(e)),
			(current, previous) => Math.max(current, previous),
		);
		Array.prototype.map.call($sections, ($section) => ($section.height = height + "px"));
	}
}

const breakSettings = {
	smallCardBreakSettings: [
		{ screen: 0, slides: 1, pager: false },
		{ screen: 460, slides: 2 },
		{ screen: 768, slides: 3 },
		{ screen: 1050, slides: 4 },
	],

	largeCardBreakSettings: [
		{ screen: 0, slides: 1 },
		{ screen: 460, slides: 3 },
	],

	contentAreaSmallCardBreakSettings: [
		{ screen: 0, slides: 1, pager: false },
		{ screen: 460, slides: 2 },
		{ screen: 768, slides: 3 },
	],
};

export { refreshSlider, breakSettings };
